import { IncomingHttpHeaders, IncomingMessage } from 'http';
import { Language } from '../types';

export const getLocaleOnSSR = (
  req: IncomingMessage & { headers?: IncomingHttpHeaders }
) => {
  const raw =
    (req.headers?.['x-forwarded-host'] as string | string[] | undefined) ??
    req.headers?.host ??
    '';
  const first = Array.isArray(raw) ? raw[0] : raw;
  const host = first.split(',')[0].trim().toLowerCase();
  const hostname = host.split(':')[0];

  const isRu = hostname.startsWith('ru.');
  return isRu ? Language.ru : Language.az;
};
